import React from 'react';
import { Circle, G, Line, Text as SvgText } from 'react-native-svg';
import { DT } from './tokens';

type Props = {
  /** Dot position — on the physical element being labeled */
  x1: number; y1: number;
  /** Label anchor position */
  x2: number; y2: number;
  /** Variable name shown in hi-vis orange monospace (e.g. "Q") */
  varName: string;
  /** Short description shown below varName in dim text */
  desc?: string;
  /** Horizontal text alignment at x2 */
  anchor?: 'start' | 'middle' | 'end';
  dotRadius?: number;
};

/**
 * Leader line with endpoint dot and variable label.
 * varName renders in hi-vis orange monospace; desc in muted grey sans.
 */
export function LeaderLine({ x1, y1, x2, y2, varName, desc, anchor = 'start', dotRadius = 3 }: Props) {
  return (
    <G>
      <Line x1={x1} y1={y1} x2={x2} y2={y2} stroke={DT.leader} strokeWidth="1" />
      <Circle cx={x1} cy={y1} r={dotRadius} fill={DT.dot} />
      <SvgText
        x={x2}
        y={y2 - 3}
        fill={DT.varColor}
        fontSize="11"
        fontFamily={DT.mono}
        fontWeight="700"
        textAnchor={anchor}
      >
        {varName}
      </SvgText>
      {desc ? (
        <SvgText
          x={x2}
          y={y2 + 10}
          fill={DT.desc}
          fontSize="8.5"
          fontFamily={DT.sans}
          textAnchor={anchor}
        >
          {desc}
        </SvgText>
      ) : null}
    </G>
  );
}
